require("custom-event-polyfill")

// Create custom event to be triggered when all images are loaded.
export const allImagesLoadedEvent = (typeof window !== 'undefined') ? new CustomEvent('allimagesloaded') : null